import React, { useState } from "react"
import api from "API/Api"
import { Row, Col, Alert, Spinner } from "reactstrap"
import MetaTags from "react-meta-tags"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"

const ChangePassword = props => {
  const [result, setResult] = useState("")
  const [submitted, setSubmitted] = useState(false)
  const [resp, setResp] = useState(false)
  const [pwdValid, setPwdValid] = useState(true)
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    setSubmitted(false)
    setResp(false)
    setErrorMsg("")
    try {
      const response = await api.post("change-password", values)
      if (response.data.success === true) {
        setResp(true)
        setResult(response.data)
        setSubmitted(true)
      } else {
        setPwdValid(false)
        setSubmitted(true)
      }
    } catch (error) {
      setErrorMsg(error.message || "Failed to change password")
      setSubmitted(true)
    }
    setLoading(false)
  }
  return (
    <>
      <Row className="">
        <Col md={12} lg={12} xl={12}>
          <div
            style={{
              background: "#fff",
              border: "1px solid #ccc",
              borderRadius: "6px",
            }}
          >
            <h4
              className="font-size-18 mb-1 text-center"
              style={{
                background: "#2b3a4a",
                color: "#fff",
                padding: "10px",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
              }}
            >
              Change Password
            </h4>
            <div className="p-3">
              <AvForm
                style={{ position: "relative" }}
                className="form-horizontal mt-4"
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v)
                }}
              >
                {errorMsg ? (
                  <Alert color="danger">{errorMsg}</Alert>
                ) : null}

                <div className="mb-3">
                  <AvField
                    name="old_password"
                    label="Current Password"
                    value=""
                    className="form-control"
                    placeholder="Enter Current Password"
                    type="password"
                    required
                  />
                </div>

                <div className="mb-3">
                  <AvField
                    name="password"
                    label="New Password"
                    value=""
                    type="password"
                    required
                    placeholder="Enter New Password"
                  />
                </div>

                <div className="mb-3">
                  <AvField
                    name="confirm_password"
                    label="Confirm New Password"
                    value=""
                    type="password"
                    required
                    validate={{
                      match: {
                        value: "password",
                        errorMessage: "Password Mismatch",
                      },
                    }}
                    placeholder="Enter Confirm Password"
                  />
                </div>

                <div className="mb-3 row mt-4">
                  <div className="col-6">
                    {submitted && resp ? (
                      <p
                        className="success"
                        style={{
                          textAlign: "right",
                          fontSize: "16px",
                          color: "rgb(32, 111, 32)",
                          fontWeight: "bold",
                        }}
                      >
                        Password Updated
                      </p>
                    ) : null}
                    {submitted && !resp ? (
                      <p
                        className="success"
                        style={{
                          textAlign: "right",
                          fontSize: "16px",
                          color: "#c12626 ",
                          fontWeight: "bold",
                        }}
                      >
                        Current Password is Invalid
                      </p>
                    ) : null}
                  </div>
                  <div className="col-6 text-end">
                    <button
                      className="btn btn-primary w-md waves-effect waves-light"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <><Spinner size="sm" /> <span>Changing...</span></>
                      ) : (
                        "Change Password"
                      )}
                    </button>
                  </div>
                </div>
              </AvForm>
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default ChangePassword
